<template lang="pug">
.middle-content-wrapper
  img.middle-title(
    v-if="!isShadowCardMonthly || signIn"
    :class="{'sign-in-card': signIn}"
    :src="signIn? 'https://m.hellobike.com/resource/gallery/919/4tCh_aKDEZ.png': goodsTitleImg"
  )
  img.middle-content(
    :class="{'sign-in-card':signIn, 'shadow-monthly-card':isShadowCardMonthly}"
    :src="middleContentImg")
</template>

<script>
export default {
  name: 'OldCardInfo',
  props: {
    isShadowCardMonthly: {
      type: Boolean,
      default: false,
    },
    signIn: {
      type: Boolean,
      default: false,
    },
    goodsTitleImg: {
      type: String,
      default: '',
    },
    middleContentImg: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
img.middle-title {
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  height: 0.25rem;

  &.sign-in-card {
    top: 0.29rem;
  }
}

.middle-content {
  display: block;
  width: 3.35rem;
  height: 2.41rem;

  &.shadow-monthly-card {
    width: 3.51rem;
    height: auto;
  }

  &.sign-in-card {
    width: 3.51rem;
    height: 3.21rem;
  }
}
</style>
